import underscore from 'underscore';

if (typeof window !== 'undefined' && typeof window._ === 'undefined') {
  window._ = underscore;
}

export default underscore;
